import type { AxiosInstance, AxiosRequestConfig } from "axios";
import { stringify } from "qs";
import addAuthInterceptor from "@rmp/core/api/shared/interceptors/authInterceptor";
import addErrorInterceptor from "@rmp/core/api/shared/interceptors/errorInterceptor";
import AbortService from "@rmp/core/services/abortService";
import { transformRequest } from "@rmp/core/utils/transformRequest";

interface GeneratedApiClient {
	instance: AxiosInstance;
}

interface GeneratedApiConfig extends AxiosRequestConfig {
	abortService: AbortService;
}

interface BaseApiControllerOptions {
	withAuthentication?: boolean;
}

export default abstract class BaseApiController<TApi extends GeneratedApiClient> {
	readonly api: TApi;
	
	protected constructor(
		createApi: (config: GeneratedApiConfig) => TApi,
		baseURL: string,
		abortService: AbortService,
		{ withAuthentication = true }: BaseApiControllerOptions = {}
	)
	{
		this.api = createApi({
			baseURL,
			abortService,
			paramsSerializer: params => stringify(params, { arrayFormat: "repeat" }),
			transformRequest
		});
		
		if(withAuthentication) {
			addAuthInterceptor(this.api.instance);
		}
		
		addErrorInterceptor(this.api.instance);
	}
}
